export const ESTADOS_MAPA = {
  SIN_PLANO: 14,
  SIN_MANZANAS: 15,
  MANZANAS_PENDIENTES: 16,
  LOTES_SIN_CONFIGURAR: 17,
  LOTES_PENDIENTES: 18,
  LOTES_SIN_ASIGNAR: 19,
  COMPLETADO: 20,
};